import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { removeEmptyFromMap } from '@shared/utils';

@Injectable()
export class ParamsInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<{}>,
    next: HttpHandler
  ): Observable<HttpEvent<{}>> {
    const params: HttpParams = new HttpParams({
      fromObject: removeEmptyFromMap(request.params)
    });
    request = request.clone({ params });
    return next.handle(request);
  }
}
